import {useCallback} from 'react';
import {useAuth} from 'reactfire';
import {usePostLoginState} from '../../navigation/hooks/usePostLoginState';
import {usePostLogoutRedirect} from '../../navigation/hooks/usePostLogoutRedirect';

interface UseLogoutOptions {
  restoreLocationOnNextLogin?: boolean;
}

/* v8 ignore next -- @preserve */
export function useLogout(options?: UseLogoutOptions): () => Promise<void> {
  const auth = useAuth();
  const postLogoutRedirect = usePostLogoutRedirect();
  const {clearPostLoginState, persistPostLoginState} = usePostLoginState();
  return useCallback(async () => {
    if (options?.restoreLocationOnNextLogin) {
      persistPostLoginState();
    } else {
      clearPostLoginState();
    }
    await auth.signOut();
    postLogoutRedirect();
  }, [auth, clearPostLoginState, options?.restoreLocationOnNextLogin, persistPostLoginState, postLogoutRedirect]);
}
